// extracted by mini-css-extract-plugin
export default {"container":"QuienesSomos_container__RiTgN","section":"QuienesSomos_section__I6Ga5","title":"QuienesSomos_title__+Ryu7","text":"QuienesSomos_text__liSTF"};